import type { NetworkAdapter } from "@luckymenu/staff-core";

/**
 * Online and offline on the web (P3-T29): `navigator.onLine` and the
 * window's `online` and `offline` events. `onLine` true only means the
 * device has some network; staff-core also watches the socket.
 */
export function webNetwork(target: Window = window): NetworkAdapter {
	return {
		isOnline: () => target.navigator.onLine !== false,
		subscribe(listener) {
			target.addEventListener("online", listener);
			target.addEventListener("offline", listener);
			return () => {
				target.removeEventListener("online", listener);
				target.removeEventListener("offline", listener);
			};
		},
	};
}
